import { Form, Select } from "antd";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
export default function StoreSelect({ originForm }) {
  const [form] = Form.useForm(originForm);
  return (
    <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}>
      <Form.Item 
        label="商家门店" 
        name="storeIds"
        rules={[
          {
            required: true,
            message: '请选择下发门店',
          },
        ]}
      >
        <ShopSelect keyVal="id" mode="multiple"/>
      </Form.Item>
    </Form>
  );
}
